document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('atsClaimPopup');

  if (!popup) return;

  const openPopup = () => {
    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ats-popup-open');
  };

  const closePopup = () => {
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ats-popup-open');
  };

  // Otwieranie po kliknięciu w każdy link/przycisk z href="#zgloszenie-szkody"
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('a[href="#zgloszenie-szkody"], button[href="#zgloszenie-szkody"]');

    if (!trigger) return;

    event.preventDefault();
    openPopup();
  });

  // Zamykanie po kliknięciu w overlay lub X
  document.addEventListener('click', function (event) {
    const closeTrigger = event.target.closest('[data-ats-close-popup]');

    if (!closeTrigger) return;

    event.preventDefault();
    closePopup();
  });

  // Zamykanie ESC
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-active')) {
      closePopup();
    }
  });
});